export default __webpack_public_path__ + "static/Date_My_Choco_2020-07-09_8074-42470b4e1a87e8916d55dfb6326cabce.jpg";